module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-09.6c720e42.jpg";